module.exports = __webpack_public_path__ + "img/ball_bearings.asm.131db4cc.jpg";